import {useMutation} from '@github-ui/react-query'
import {apiCreateMilestone, type CreateMilestoneRequest} from '../api/api-create-milestone'
import {parseGraphQLResponse} from '@github-ui/item-picker-base/api/graphql'

export const useCreateMilestoneMutation = () => {
  return useMutation({
    mutationFn: async (request: CreateMilestoneRequest) => {
      const responseJson = await apiCreateMilestone(request)
      const responseData = parseGraphQLResponse(responseJson)
      return responseData.data.createMilestone?.milestone ?? null
    },
  })
}
